import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import EndMeetingForAll from '../Buttons/EndMeetingForAll/EndMeetingForAll';
import Menu from '../MenuBar/Menu/Menu';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import Dailer from '../Assets/logo1.png';
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: 'white',
    paddingLeft: '1em',
    display: 'none',
    height: `${theme.mobileTopBarHeight}px`,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  endCallButton: {
    height: '28px',
    fontSize: '0.85rem',
    padding: '0 0.6em',
  },
  settingsButton: {
    [theme.breakpoints.down('sm')]: {
      height: '28px',
      minWidth: '28px',
      border: '1px solid rgb(136, 140, 142)',
      padding: 0,
      margin: '0 1em',
    },
  },
}));

export default function MobileTopMenuBar() {
  const classes = useStyles();
  const participants = useParticipants();
  const { room } = useVideoContext();
  const { search, state } = useLocation();
  const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
  const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
  const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
  const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
  const Type = (state as { state: { Type: string } }).state.Type;

  return (
    <div className="container-fluid header">
      <div className="row">
        {/* <div className="col-sm-10"></div> */}
        <div className="col-sm-10">
          {' '}
          <img src={Dailer} />
        </div>
        <div className="col-sm-2">
          <div className="container-fluid mymobsbtn">
            <div className="row">
              <div className="col-sm-4">
                <p>
                  Participant{participants.length ? 's' : ''} :<span> {participants.length + 1}</span>
                </p>
              </div>
              <div className="col-sm-8">
                <div className="row">
                  <EndCallButton className={classes.endCallButton} />
                  {Type == 'Host' ? <EndMeetingForAll className={classes.endCallButton} /> : <></>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
